module.exports = __webpack_public_path__ + "img/zsjm-2.1c6a3c31.webp";